<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      size="mini"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_versionNo') || '版本编号'"
                prop="versionNo"
              >
                <el-input-number
                  v-model="formData.versionNo"
                  :precision="0"
                  :controls="false"
                  :max="999999999"
                  :min="0"
                  style="width: 100%"
                  :placeholder="
                    $l('form_placeholder_versionNo') || '请输入版本编号'
                  "
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_versionName') || '版本名称'"
                prop="versionName"
              >
                <el-input
                  v-model="formData.versionName"
                  maxlength="20"
                  :placeholder="
                    $l('form_placeholder_versionName') || '请输入版本名称...'
                  "
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_forceUpdate') || '是否强制更新'"
                prop="forceUpdate"
              >
                <el-select
                  v-model="formData.forceUpdate"
                  :placeholder="$l('form_placeholder_forceUpdate') || '请选择'"
                  clearable
                  style="width: 100%"
                >
                  <el-option label="是" value="Y" />
                  <el-option label="否" value="N" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_platform') || '适用平台'"
                prop="platform"
              >
                <el-select
                  v-model="formData.platform"
                  :placeholder="
                    $l('form_placeholder_platform') || '请选择适用平台'
                  "
                  clearable
                  style="width: 100%"
                >
                  <el-option label="Android" value="Android" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_updateContent') || '版本更新内容'"
            prop="updateContent"
          >
            <br />
            <div>
              <quill-editor
                :disabled="disabled"
                v-model="formData.updateContent"
                :options="editorOptions"
              />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_remarks') || '备注'"
            prop="remarks"
          >
            <el-input
              maxlength="500"
              v-model="formData.remarks"
              :placeholder="$l('form_placeholder_remarks') || '请输入备注...'"
              type="textarea"
              :rows="2"
              clearable
            />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-upload
            drag
            action="#"
            :file-list="listFile"
            :auto-upload="false"
            :on-change="uploadCustFileChange"
            :on-remove="removeFileChange"
            :accept="uploadFileAccept"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text" v-if="!disabled">
              {{ $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或'
              }}<em> {{ $l('INDEX.file_upload_tips_last') || '点击上传' }}</em>
            </div>
          </el-upload>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    versionCode: String,
    params: { type: Object, default: () => {} },
  },
  components: {
    quillEditor,
  },
  data() {
    return {
      editorOptions: {
        modules: {
          toolbar: [
            'bold',
            'italic',
            'underline',
            'strike',
            { list: 'ordered' },
            { list: 'bullet' },
            { script: 'sub' },
            { script: 'super' },
            { color: [] },
            { background: [] },

            { size: ['small', false, 'large', 'huge'] },
          ],
        },
      },
      formData: { forceUpdate: 'Y', platform: 'Android' },
      uploadFileAccept: '.apk,.APK',
      listFile: [],
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    rules() {
      return {
        versionNo: [
          {
            required: true,
            message: this.$l('form_placeholder_versionNo') || '请输入版本编号',
            trigger: 'blur',
          },
        ],
        versionName: [
          {
            required: true,
            trigger: 'blur',
            message:
              this.$l('form_placeholder_versionName') || '请输入版本名称',
          },
        ],
      }
    },
  },
  methods: {
    getData() {
      if (!this.versionCode) return

      this.$api
        .appVersionRecordsDetailApi({
          versionCode: this.versionCode,
        })
        .then((res) => {
          this.formData = res.body
          const { fileName, downloadUrl } = res.body
          this.listFile = [{ name: fileName, url: downloadUrl }]
        })
    },

    async uploadCustFileChange(f, fileList) {
      const acceptedTypes = this.uploadFileAccept
        ? this.uploadFileAccept.split(',')
        : []

      const fileType = f.name.substring(f.name.lastIndexOf('.'))

      if (acceptedTypes.length && !acceptedTypes.includes(fileType)) {
        fileList.splice(fileList.length - 1, 1)
        this.$message.error(`文件[${f.name}]不支持上传`)
        return
      }

      this.loadingOpen()
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      const res = await this.uploadFiles(fileList)
      this.loadingClose()
      if (!res || !res[0]) return
      const { fileSize, fileUrl, fileName } = res[0]
      this.formData.fileSize = fileSize
      this.formData.downloadUrl = fileUrl
      this.formData.fileName = fileName
    },
    async removeFileChange() {
      this.formData.fileSize = ''
      this.formData.downloadUrl = ''
    },
    async uploadFiles(listDoc) {
      if (!listDoc?.length) return Promise.resolve([])

      const uploadTask = listDoc.map((file) => {
        return this.$api
          .SYS_UPLOAD(file.raw)
          .then((res) => ({
            fileCode: res.body.fileId,
            fileUrl: res.body.url,
            fileName: file.name,
            fileSize: this.formatFileSize(file.size),
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
    formatFileSize(bytes) {
      return (bytes / (1024 * 1024)).toFixed(2)
    },

    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      if (!this.formData.downloadUrl) {
        this.$message.warning(`请选择PAD应用文件`)
        return
      }
      this.loadingOpen()
      this.$api
        .appVersionRecordsSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
<style scoped lang="scss">
// 调整样式
:deep(.ql-editor) {
  min-height: 140px;
}

:deep(.ql-toolbar.ql-snow) {
  padding: 0px;
}
::v-deep .ql-editor {
  min-height: 150px;
}
</style>
